import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useEffect, useState } from "react";
import { useGetSubQuotationMutation } from "src/services/api-service/quotations";

export default function useGetSubQuotation(id: string | undefined) {
  const [getSubQuotation] = useGetSubQuotationMutation();
  const [data, setData] = useState<any>(null);
  const [isPending, setIsPending] = useState(false);
  const [isError, setIsError] = useState<
    FetchBaseQueryError | SerializedError | null
  >(null);

  useEffect(() => {
    if (!id) return;

    let ignore = false;

    const getData = async () => {
      if (ignore) return;

      setIsPending(true);

      const res = await getSubQuotation({ id });

      if ("data" in res) {
        setData(res.data.data);
        setIsPending(false);
      } else if ("error" in res) {
        setIsError(res.error);
        setIsPending(false);
      }
    };

    getData();

    return () => {
      ignore = true;
    };
  }, [id]);

  return { isPending, isError, data };
}
